import { render, staticRenderFns } from "./AffiliateStatistic.vue?vue&type=template&id=c1290e20&scoped=true"
import script from "./AffiliateStatistic.vue?vue&type=script&lang=js"
export * from "./AffiliateStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1290e20",
  null
  
)

export default component.exports